export default {
      id: "menu_back-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#menu_back-usage",
      toString: function () {
        return this.url;
      }
    }